/**
 * ResponsibilityStageBadge — calm visual chip showing the learner's
 * current ownership stage for the competency.
 *
 * Stages (locked vocabulary):
 *   instructor_led — instructor owns all decisions
 *   shared         — some responsibilities transferred
 *   learner_owned  — learner owns all decisions
 */
import { User, Users, UserCheck } from "lucide-react";

const STAGES = {
  instructor_led: {
    label: "Instructor-led",
    Icon: User,
    classes: "bg-slate-100 text-slate-700 border-slate-300",
  },
  shared: {
    label: "Shared",
    Icon: Users,
    classes: "bg-amber-50 text-amber-800 border-amber-300",
  },
  learner_owned: {
    label: "Learner-owned",
    Icon: UserCheck,
    classes: "bg-emerald-50 text-emerald-800 border-emerald-300",
  },
};

export default function ResponsibilityStageBadge({ stage, mode }) {
  const s = STAGES[stage] || STAGES.instructor_led;
  const { Icon } = s;
  const modeLabel = mode === "independent" ? "Independent" : "Guided";
  return (
    <div
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border ${s.classes}`}
      data-testid="responsibility-stage-badge"
      data-stage={stage}
      data-mode={mode}
    >
      <Icon size={13} />
      <span className="text-xs font-semibold">{s.label}</span>
      <span className="text-[10px] opacity-70 border-l border-current/30 pl-1.5 ml-0.5">
        {modeLabel}
      </span>
    </div>
  );
}
